import { withRouter } from 'react-router';
import ErrorBoundary from './ErrorBoundary';

export default withRouter(ErrorBoundary);
